import React from 'react';
import './ArtisticCareer.css';

const ArtisticCareer: React.FC = () => {
  return (
    <section className="artistic-career">
      <div className="container">
        <h2>Artistic Career</h2>

        <div className="artistic-style">
          <h3>Artistic Style and Identity</h3>

          <div className="nocturnal-painter">
            <h4>"The Nocturnal Painter"</h4>
            <ul>
              <li>Self-described "nocturnal painter" who worked primarily at night</li>
              <li>Nationally recognized for street-corner scenes of his old New York neighborhood</li>
              <li>Known for capturing the freedom and emotion of night life</li>
            </ul>
          </div>

          <div className="artistic-themes">
            <h4>Artistic Themes:</h4>
            <ul>
              <li>Street-corner scenes from Brooklyn neighborhoods</li>
              <li>Nightlife and urban themes</li>
              <li>Semi-cubist landscapes of the Pacific Northwest</li>
              <li>Russian street scenes from his international travel</li>
            </ul>
          </div>
        </div>

        <div className="exhibitions">
          <h3>Major Exhibitions and Recognition</h3>

          <div className="international-recognition">
            <h4>International Recognition</h4>

            <div className="soviet-exhibition">
              <h5>Soviet Union Exhibition (1990)</h5>
              <ul>
                <li>One of only ten U.S. artists selected to exhibit in the Soviet Union</li>
                <li>Found "most receptive and fun warm reception of the people"</li>
                <li>Created paintings based on street scenes from his trip to Russia</li>
                <li>Quote: "This was done when I was in Moscow, Russia. Since I am a night person, I waited for midnight..."</li>
              </ul>
            </div>
          </div>

          <div className="local-exhibitions">
            <h4>Local and Regional Exhibitions</h4>

            <div className="tacoma-art-walk">
              <h5>Tacoma's Third Thursday Art Walk</h5>
              <ul>
                <li>Featured artist for poster artwork</li>
                <li>Expanding nightlife theme artwork displayed at Broadway Center Gallery</li>
              </ul>
            </div>

            <div className="gallery-exhibitions">
              <h5>Gallery Exhibitions:</h5>
              <ul>
                <li>Broadway Center Gallery, 936 Broadway, Downtown Tacoma</li>
                <li>Art show running through June 15 (date from documents)</li>
                <li>Sponsored by Theater District Associates</li>
                <li>Gallery hours: noon-6 p.m. Tuesdays-Wednesdays, noon-8 p.m. Thursdays-Sundays</li>
              </ul>
            </div>

            <div className="other-exhibitions">
              <h5>Other Notable Exhibitions:</h5>
              <ul>
                <li>Lakewood Library Gallery - showing two pieces</li>
                <li>AAA Art & Design Studio - Two man art show</li>
                <li>Interior Decorating & Design School in Seattle - six pieces</li>
                <li>Bellevue Art Show exhibition</li>
                <li>First Night Gallery showcase (December 29, 1992)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="awards">
          <h3>Awards and Achievements</h3>

          <div className="purchase-awards">
            <h4>Purchase Awards:</h4>
            <ul>
              <li>Purchase Award Recipient in first annual Galleries Fleet</li>
              <li>Work included in newly established Galleries permanent collection</li>
            </ul>
          </div>

          <div className="fair-competitions">
            <h4>Fair Competitions:</h4>
            <ul>
              <li>Fourth prize Western Washington Fair in Puyallup, Washington (multiple years)</li>
              <li>Western Washington Fair - placed fourth in 2 categories and Honorable Mention</li>
            </ul>
          </div>

          <div className="religious-art">
            <h4>Religious Art:</h4>
            <ul>
              <li>St Thomas More Juried Christian Art Show - Won 2nd Place Award and Spangle Award</li>
            </ul>
          </div>

          <div className="proposals">
            <h4>Proposals and Submissions:</h4>
            <ul>
              <li>Submitted proposal for Art Bus program in Tacoma</li>
              <li>Betty Bowen Memorial Fund - Seattle Art Museum (submitted slides)</li>
              <li>1989 Artist fellowship awards (submitted several slides)</li>
            </ul>
          </div>
        </div>

        <div className="professional-recognition">
          <h3>Professional Recognition</h3>

          <div className="american-artist-magazine">
            <h4>American Artist Magazine:</h4>
            <ul>
              <li>Featured in "Illustrated survey of leading contemporaries"</li>
              <li>Selected for worldwide distribution at museums & book stores</li>
              <li>Spotlighted as "up and coming" artist whose work is "just beginning to get attention at Museums and Galleries"</li>
            </ul>
          </div>
        </div>

        <div className="gallery-ownership">
          <h3>Gallery Ownership</h3>

          <div className="continuous-spectrum">
            <h4>Continuous Spectrum Gallery</h4>
            <ul>
              <li>Owned and operated art gallery in downtown Tacoma</li>
              <li>Featured in news articles about challenges facing local galleries</li>
              <li>Part of Tacoma's art scene revitalization efforts</li>
            </ul>
          </div>
        </div>

        <div className="mural-work">
          <h3>Mural Work</h3>

          <div className="major-murals">
            <h4>Major Mural Projects:</h4>
            <ul>
              <li>10'x10' - Tacoma Lakeview School in Lakewood</li>
              <li>4'x10' - Mural for Mrs. Billy Smith, 6th Ave. Tacoma</li>
              <li>7 Murals for Riverside Body building School, 24th St. Tacoma</li>
              <li>3 Murals for Iron Age Gym on Broadway in Tacoma</li>
              <li>2 Murals for Victory Body building - "The Gold Cup" - Lakewood</li>
              <li>2 Murals for Tacoma Gym "The Gold Cup"</li>
              <li>1 Mural for Bodyshape Gym in Portland Ave., Tacoma</li>
            </ul>
          </div>
        </div>

        <div className="specific-artworks">
          <h3>Specific Artworks Mentioned</h3>

          <div className="desperate-view">
            <h4>"Desperate View" (30x40 acrylic on canvas)</h4>
            <ul>
              <li>Currently displayed in gallery window</li>
              <li>Artist note: "I looked a long time planning to work on this piece."</li>
            </ul>
          </div>

          <div className="midnight-walk">
            <h4>"Midnight Walk in Moscow" (27 by 36 Red Tempera on Magnolia)</h4>
            <ul>
              <li>Triggered by midnight memories from Russia</li>
              <li>Artist note: "I went down every street, I could feel the romance, The mystery."</li>
            </ul>
          </div>

          <div className="movement">
            <h4>"Movement" (30 by [dimensions partially visible])</h4>
          </div>
        </div>

        <div className="media-coverage">
          <h3>Media Coverage</h3>

          <div className="major-features">
            <h4>Major News Features:</h4>
            <ul>
              <li>Tribune SoundLife Magazine - "Window of no opportunity" (July 11, 1996)</li>
              <li>"Finding Light in the Darkness" - The News Tribune (January 10, 1993)</li>
              <li>"Art without boundaries" - Feature article</li>
              <li>Tacoma City Paper - "Welcome To The NEW D.A.Y." (August 20-26, 1991)</li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ArtisticCareer;